// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3m1n9","title":"Images45_title__1Stoc","images":"Images45_images__1FwEZ"};